import { useAssistantAccess } from 'src/pages/Assistant/useAssistantAccess.hook';
import SidebarContent from './SidebarContent.component';

export default function Sidebar() {
  const assistant = useAssistantAccess();
  return <SidebarContent assistantVisible={assistant.visible} />;
}
